const errorMessageStyle = {
  typography: {
    fontSize: "16px",
    lineHeight: "2",
    fontWeight: "300",
    fontFamily: 'Emeric,Arial,sans-serif',
    color: "rgb(102, 60, 0)",
    backgroundColor: "rgba(255, 216, 51, 0.2)",
    padding: "24px",
    borderRadius: "4px",
    "@media (max-width: 520px)": {
      lineHeight: "1.5",
      padding: "24px 16px",
    },
  },
};

export default errorMessageStyle;
